module.exports = __webpack_public_path__ + "media/assets/img/authot_studio_logo-2c4ae524dfa02588746c01a38cfaca25.png";